import Loader from "./Loader.container";

export default Loader;
